import(/* webpackMode: "eager", webpackExports: ["default"] */ "G:\\Nexo3d.ir\\node_modules\\lucide-react\\dist\\esm\\Icon.mjs");
;
import(/* webpackMode: "eager" */ "G:\\Nexo3d.ir\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager", webpackExports: ["CatalogBrowser"] */ "G:\\Nexo3d.ir\\src\\components\\catalog-browser.tsx");
;
import(/* webpackMode: "eager" */ "G:\\Nexo3d.ir\\src\\components\\seo-guide.module.css");
